import { FC } from 'react'
import Toolbar from '@mui/material/Toolbar'
import { AppBar, Box, Grid } from '@mui/material'
import { Wallet } from '../Wallet/Wallet'
import { NAV_BAR_SCREEN_MIN_WIDTH_FOR_WALLET_BUTTON } from '../../utils/constants'
import { useSelector } from 'react-redux'
import { getScreen } from '../../redux/modules/app'

export const NavBar: FC = () => {
  const { windowWidth } = useSelector(getScreen)
  const smallScreen = windowWidth < NAV_BAR_SCREEN_MIN_WIDTH_FOR_WALLET_BUTTON

  return (
    <AppBar position="static" className="App-bar">
      <Toolbar variant="regular">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={smallScreen ? 6 : 9}>
              <img src="/kong-logo.png" alt="Kong" className={'App-logo'} />
            </Grid>
            {smallScreen ? (
              <Grid item xs={6}>
                <div style={{ textAlign: 'right' }}>
                  <Wallet />
                </div>
              </Grid>
            ) : (
              <Grid item xs={3}>
                <div style={{ textAlign: 'right' }}>
                  <Wallet />
                </div>
              </Grid>
            )}
          </Grid>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
